<template>
  <div id="footer" class="footer">
    <!-- <div class="center-block">
        <img class="share-link" alt="Facebook - White Circle" src="../assets/facebook.png" >
        <img class="share-link" alt="Pinterest - White Circle" src="../assets/pointer.png" >
        <img class="share-link" alt="Instagram - White Circle" src="../assets/inst.png">
      </div> -->
    <p><span>© 2023&nbsp;by Wejoyo</span></p>
    <p><span>北京奇点光年科技有限公司</span></p>
    <p>
      <span><a href="https://www.wejoyo.com/termofservice">Term of Service</a></span>
      &nbsp;&nbsp;
      <span><a href="https://www.wejoyo.com/privacy">Privacy</a></span>
    </p>

  </div>
</template>

<script>
export default {
  data: function () {
    return {
      beianShow: beianShow()
    }
  }
}

function beianShow() {
  var lang = navigator.language || navigator.userLanguage;
  lang = lang.toUpperCase();
  console.log(lang)
  return "ZH-CN" == lang;
}


</script>
<style>
.beian a:link {
  color: #333;
}

.beian a:visited {
  color: #333;
}

.beian a:hover {
  color: #333;
}

.footer {
  background-color: #333;
  color: #aaa;
  padding: 30px;
}</style>



// WEBPACK FOOTER //
// src/components/Footer.vue